import { render, staticRenderFns } from "./SchoolLookup.vue?vue&type=template&id=1714b844&scoped=true&"
import script from "./SchoolLookup.vue?vue&type=script&lang=js&"
export * from "./SchoolLookup.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLookup.vue?vue&type=style&index=0&id=1714b844&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1714b844",
  null
  
)

export default component.exports